import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import * as Sentry from '@sentry/browser';
import App from 'next/app';
import Head from 'next/head';
import { withRouter } from 'next/router';
import { ConfigProvider } from 'vcc-ui';
import blogPosts from '../blog-manifest.json';
import FelaWrapper from '../components/fela-wrapper';
import { blogComponents, MDXComponents } from '../components/mdx';
import { NextLinkWrapper } from '../components/next-link-wrapper';
import BlogLayout from '../layouts/blog';
import DocsLayout from '../layouts/docs';

const getLayoutByType = (type) => {
  if (type === 'blog') {
    return BlogLayout;
  }
  return DocsLayout;
};

Sentry.init({
  dsn: process.env.SENTRY_DSN,
});

class MyApp extends App {
  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
    super.componentDidCatch(error, errorInfo);
  }

  constructor(props) {
    super(props);
    this.state = {
      currentTheme: 'light',
    };
  }

  setCurrentTheme(theme) {
    this.setState({
      currentTheme: theme,
    });
  }

  render() {
    const { Component, pageProps, renderer } = this.props;
    const path = this.props.router.pathname;
    const pathType = path.split('/')[1];
    const currentTheme = this.state.currentTheme;
    const setCurrentTheme = this.setCurrentTheme.bind(this);

    return (
      <>
        <Head>
          <title>VCC UI</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <MDXProvider
          components={{
            wrapper: function MdxWrapper({ ...props }) {
              const Wrapper = getLayoutByType(pathType);
              let title = false;
              if (pathType === 'blog') {
                title = blogPosts.filter((post) => post.path === path)[0].title;
              }
              return (
                <Wrapper
                  currentTheme={currentTheme}
                  setCurrentTheme={setCurrentTheme}
                  title={title}
                  {...props}
                />
              );
            },
            ...MDXComponents,
            ...(pathType === 'blog' &&
              blogComponents(
                blogPosts.filter((post) => post.path === path)[0]
              )),
          }}
        >
          <ConfigProvider config={{ linkComponent: NextLinkWrapper }}>
            <FelaWrapper currentTheme={currentTheme} renderer={renderer}>
              <Component {...pageProps} />
            </FelaWrapper>
          </ConfigProvider>
        </MDXProvider>
      </>
    );
  }
}

export default withRouter(MyApp);
